(() => {
  const key = 'shopify-wishlist';
  const buttonSelector = '.add-wishlist,[button-wishlist],.wishlist-btn';
  const config = document.getElementById('db-wishlist-labels');
  if (!config) return;
  const labels = JSON.parse(config.textContent);
  const productRoot = `${window.Shopify?.routes?.root || '/'}products/`;
  let renderVersion = 0;
  let toastTimer;
  const handles = () => {
    try { return [...new Set((localStorage.getItem(key) || '').split(',').filter(handle => /^[a-z0-9-]+$/.test(handle)))]; }
    catch { return []; }
  };
  const handleOf = button => button.getAttribute('data-product-handle') || button.getAttribute('data-product_handle');
  const announce = message => {
    const status = document.getElementById('db-wishlist-status');
    if (!status) return;
    clearTimeout(toastTimer); status.textContent = message; status.classList.add('is-visible');
    toastTimer = setTimeout(() => status.classList.remove('is-visible'), 2600);
  };
  const refresh = () => {
    const saved = handles();
    document.querySelectorAll(buttonSelector).forEach(button => {
      const active = saved.includes(handleOf(button));
      button.classList.toggle('added', active);
      button.setAttribute('aria-label', active ? labels.remove : labels.add);
      button.setAttribute('aria-pressed', String(active)); button.setAttribute('role', 'button');
      if (!button.hasAttribute('tabindex')) button.tabIndex = 0;
    });
    document.querySelectorAll('.dtxc-wishlist-count').forEach(counter => {
      const count = counter.querySelector('span'); if (count && count.textContent !== String(saved.length)) count.textContent = String(saved.length);
      counter.style.display = saved.length ? 'block' : 'none';
    });
  };
  const stateCard = (message, action, listener) => {
    const wrapper = document.createElement('div'); wrapper.className = 'db-wishlist-empty';
    const text = document.createElement('p'); text.textContent = message; wrapper.append(text);
    if (action) {
      const button = document.createElement(listener ? 'button' : 'a'); button.className = 'button button--primary'; button.textContent = action;
      if (listener) { button.type = 'button'; button.addEventListener('click', listener); }
      else button.href = labels.catalog;
      wrapper.append(button);
    }
    return wrapper;
  };
  const render = async () => {
    const grid = document.querySelector('[grid-wishlist]'); if (!grid) return;
    const version = ++renderVersion; const saved = handles(); grid.classList.remove('empty-list');
    if (!saved.length) { grid.replaceChildren(stateCard(labels.empty, labels.browse)); return; }
    grid.replaceChildren(stateCard(labels.loading));
    const results = await Promise.allSettled(saved.map(async handle => {
      const response = await fetch(`${productRoot}${encodeURIComponent(handle)}?view=card`);
      if (!response.ok) throw new Error('Product unavailable');
      const content = new DOMParser().parseFromString(await response.text(), 'text/html');
      const card = content.querySelector('.wishlist__grid-item'); if (!card) throw new Error('Product card unavailable');
      card.querySelectorAll('script').forEach(script => script.remove()); return document.importNode(card, true);
    }));
    if (version !== renderVersion || !grid.isConnected) return;
    const cards = results.filter(result => result.status === 'fulfilled').map(result => result.value);
    grid.replaceChildren(...cards);
    if (cards.length !== saved.length) grid.append(stateCard(labels.error, labels.retry, render));
    grid.classList.add('loaded'); refresh();
  };
  const toggle = button => {
    const handle = handleOf(button); if (!handle || !/^[a-z0-9-]+$/.test(handle)) return;
    const saved = handles(); const exists = saved.includes(handle);
    const updated = exists ? saved.filter(value => value !== handle) : [...saved, handle];
    try { if (updated.length) localStorage.setItem(key, updated.join(',')); else localStorage.removeItem(key); }
    catch { announce(labels.storage); return; }
    refresh(); render(); announce(exists ? labels.removed : labels.added);
  };
  const start = () => {
    document.addEventListener('click', event => {
      const button = event.target.closest(buttonSelector); if (!button) return;
      event.preventDefault(); toggle(button);
    });
    document.addEventListener('keydown', event => {
      const button = event.target.closest(buttonSelector);
      if (button && (event.key === ' ' || (event.key === 'Enter' && !button.hasAttribute('href')))) { event.preventDefault(); toggle(button); }
    });
    window.addEventListener('storage', event => { if (event.key === key) { refresh(); render(); } });
    document.addEventListener('shopify:section:load', () => { refresh(); render(); });
    new MutationObserver(refresh).observe(document.body, {childList:true,subtree:true}); refresh(); render();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true}); else start();
})();
